<template>
    <v-layout row>
      <v-flex grow class="pa-2">
        <v-alert
          v-for="s in upcomingShifts"
          :value="s"
          type="warning"
          :key="s.id"
        >
          Shift Reminder - 
          <router-link :to="{ name: 'shiftDetail', params: { shiftId: s.id } }" class="white--text font-weight-bold">
            {{ s.start_datetime | moment("dddd, MMMM DD [at] h:mma") }}
          </router-link>
          {{ s.worksite.name }}
        </v-alert>
      </v-flex>
    </v-layout>
</template>

<script>
import shiftApi from '@/api/shift'

export default {
  data() {
    return {
      upcomingShifts: [],
    }
  },
  created() {
    shiftApi.getCurrentUserTwoDays(shifts => {
      if (shifts.length > 0) {
        this.upcomingShifts = shifts
      }
    })
  },
}
</script>

